import { render, staticRenderFns } from "./shopdetails.vue?vue&type=template&id=83ab68cc&scoped=true&"
import script from "./shopdetails.vue?vue&type=script&lang=js&"
export * from "./shopdetails.vue?vue&type=script&lang=js&"
import style0 from "./shopdetails.vue?vue&type=style&index=0&id=83ab68cc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83ab68cc",
  null
  
)

export default component.exports